// Array of objects 
export const bookArr = [
	{
		id: 1,	// key prop
		bookImg: 'https://images-eu.ssl-images-amazon.com/images/I/71NiPFoJx1L._UX300__PJku-sticker-v7,TopRight,0,-50__BG0,0,0,0_FMpng_AC_UL200_SR200,200_.jpg',
		bookName: 'The Morning Star',
		bookAuthor: 'Gita V.reddy',
		bookPrice: 'Rs 293.00',
	},
	{
		id: 2,
		bookImg: 'https://images-eu.ssl-images-amazon.com/images/I/91n6oKUsMnL._UX300__PJku-sticker-v7,TopRight,0,-50__BG0,0,0,0_FMpng_AC_UL200_SR200,200_.jpg',
		bookName: 'Lost: Darkness to Light',
		bookAuthor: "Delton D'Souza",
		bookPrice: 'Rs 99.00',
	},
	{
		id: 3,
		bookImg: 'https://images-eu.ssl-images-amazon.com/images/I/91n6oKUsMnL._UX300__PJku-sticker-v7,TopRight,0,-50__BG0,0,0,0_FMpng_AC_UL200_SR200,200_.jpg',
		bookName: 'Lost: Darkness to Light',
		bookAuthor: "Delton D'Souza",
		bookPrice: 'Rs 99.00',
	},
	{
		id: 4,
		bookImg: 'https://images-eu.ssl-images-amazon.com/images/I/91n6oKUsMnL._UX300__PJku-sticker-v7,TopRight,0,-50__BG0,0,0,0_FMpng_AC_UL200_SR200,200_.jpg',
		bookName: 'Lost: Darkness to Light',
		bookAuthor: "Delton D'Souza",
		bookPrice: 'Rs 99.00',
	},
]
